import styled from 'styled-components';
import { ServicePageContainer } from '../../features/services/services-page-container/services-page-container.styles';
import { ServicesSubSectionContainer } from '../../features/services/services-subsection/services-subsection.styles';

export const PersonalDataContainer = styled(ServicePageContainer)`
  ${ServicesSubSectionContainer}:nth-child(4) {
    form .inputs {
      display: grid;
      width: 100%;
      row-gap: 2rem;
      grid-template-columns: 80% 20%;
      padding-right: 2.4rem;

      > * {
        grid-column: 1 / -1;
      }

      > *:nth-child(4),
      > *:nth-child(5) {
        grid-column: span 1;
      }

      @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding-right: 0;

        > *:nth-child(4),
        > *:nth-child(5) {
          grid-column: 1 / -1;
        }
      }
    }
  }

  ${ServicesSubSectionContainer}:nth-child(3) {
    .location-inputs {
      display: flex;
      gap: 2.4rem;
      max-width: 724px;

      @media (max-width: 750px) {
        flex-direction: column;
        gap: 1.6rem;
      }
    }
  }
`;
